/* eslint-disable @typescript-eslint/no-explicit-any */
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { base } from '@/base/base'
import { PopupViews } from '@/defines/EnumDefine'
import { wsClient } from '@/net/WebSocketClient'
import { MsgIDs } from '@/defines/MsgIDs'
import * as proto from '@/proto/proto.js'

interface TurnItem {
  nickname: string
  type: number
}

export class TurnTableModule extends ModuleBase {
  public turnList: TurnItem[] = []
  public turnInfo: proto.ClientDrawNumAck | null = null
  public turnReward: proto.ClientTurntableAck | null = null

  public onceShow = false //为了第一次进来展示弹窗使用的

  init(): void {
    this.onceShow = false
    this.turnInfo = null
    this.turnList = []
    this.turnReward = null
  }

  onClear(): void {
    this.onceShow = false
    this.turnInfo = null
    this.turnList = []
    this.turnReward = null
  }

  onLoad(): void {}

  onDestroy(): void {}

  inits2c(): void {
    ;(hall.s2c as any)['onClientDrawNumAck'] = function (msg: proto.ClientDrawNumAck) {
      hall.turnTableModule.setTurnInfo(msg)
      hall.eventDispatcher.emit(hall.EventDefine.TurnTableChange)
      hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新实物大转盘红点
      hall.eventDispatcher.emit(hall.EventDefine.GoodsListChange)

      if (!hall.turnTableModule.onceShow) {
        hall.turnTableModule.onceShow = true
        hall.popupViewModule.resume()
        // @ts-expect-error: isLoadingNow does not exist on array representation of moduleManager
        hall.moduleManager.isLoadingNow = true
        hall.addCashModule.postGoodsInfoReq()
        //hall.turnTableModule.popupView()
      }
    }

    ;(hall.s2c as any)['onClientTurntableAck'] = function (msg: proto.ClientTurntableAck) {
      if (msg.ret != 0) {
        hall.eventDispatcher.emit(hall.EventDefine.TurnTableOpen)
        return
      }
      hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新实物大转盘红点
      hall.turnTableModule.changeTurnList(msg)
      hall.eventDispatcher.emit(hall.EventDefine.TurnTableReward)
    }
  }

  //前端获取转盘抽奖次数
  postTurnInfo(): void {
    const msg = {
      UserID: hall.userModule.userId,
    }
    wsClient.send(MsgIDs.ClientDrawNumReq, msg)
  }

  //点击转盘活动
  postTurnTableSpin(): void {
    const msg = {
      UserID: hall.userModule.userId,
      ChannelID: base.channelId,
    }
    wsClient.send(MsgIDs.ClientTurntableReq, msg)
  }

  onPreloadData(): void {
    this.postTurnInfo()
    this.initTurnList()
  }

  setTurnInfo(data: proto.ClientDrawNumAck) {
    this.turnInfo = data
  }

  getTurnInfo() {
    return this.turnInfo
  }

  //模拟假信息
  initTurnList() {
    const name = this.generateGuestIds()
    this.turnList = [
      { nickname: name[0] || '', type: 1 },
      { nickname: name[1] || '', type: 2 },
      { nickname: name[2] || '', type: 1 },
      { nickname: name[3] || '', type: 2 },
    ]
    for (let i = 0; i < 96; i++) {
      const num = Math.floor(Math.random() * 6) + 3
      const data = { nickname: name[i + 4] || '', type: num }
      this.turnList.push(data)
    }
    this.turnList.sort(() => Math.random() - 0.5)
  }

  generateGuestIds(): string[] {
    const guestIds: string[] = []
    for (let i = 0; i < 100; i++) {
      // 生成0-9999的随机数
      const randomNum = Math.floor(Math.random() * 10000)
      // 转换为4位字符串，不足补零
      const numStr = randomNum.toString().padStart(4, '0')
      // 隐藏前两位
      const hiddenId = `Guest**${numStr.substring(2)}`
      guestIds.push(hiddenId)
    }
    return guestIds
  }

  maskUsername = (username: string) => {
    const guestPos = username.indexOf('Guest')
    if (guestPos === -1) return username
    return username.slice(0, guestPos + 5) + '**' + username.slice(guestPos + 7)
  }

  changeTurnList(msg: proto.ClientTurntableAck) {
    //添加玩家奖励
    this.turnReward = msg
    const nameData = this.maskUsername(hall.userModule.userName)
    const data = { nickname: nameData, type: msg.TurnID }
    this.turnList[0] = data
    this.turnList.sort(() => Math.random() - 0.5)
    hall.eventDispatcher.emit(hall.EventDefine.TurnTableChangTipsChange)
  }

  getTurnList() {
    return this.turnList
  }

  getTurnReward() {
    return this.turnReward
  }

  //是否侧边栏展示这个活动
  isShowTurnBind() {
    const goodsInfo = hall.addCashModule.getGoodsInfos()
    if (goodsInfo && goodsInfo.first_pay) {
      return true
    }
    if (this.turnInfo != null && this.turnInfo.Dnum > 0) {
      return true
    }
    return false
  }

  // 是否需要弹窗
  popupView() {
    //1，未充值的新玩家，每次返回大厅都弹，权重最高
    //2，已充值的玩家，有抽奖次数未消耗时，每次都弹出，权重最高，一直到抽奖机会用掉。
    //3，已充值的玩家，且抽过了，没有次数了。这个活动所有入口消失。

    const goodsInfo = hall.addCashModule.getGoodsInfos()
    if (goodsInfo && goodsInfo.first_pay) {
      hall.popupViewModule.addPopupView(PopupViews.TurnTablePanel)
    } else {
      if (this.turnInfo != null && this.turnInfo.Dnum > 0) {
        hall.popupViewModule.addPopupView(PopupViews.TurnTablePanel)
      }
    }
  }
}
